const DB_NAME = 'country-dance-hub';
const DB_VERSION = 1;
const STORES = ['songs', 'choreographies', 'associations', 'cache_meta'];

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      STORES.forEach((name) => {
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name, { keyPath: name === 'cache_meta' ? 'key' : 'id' });
        }
      });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error('IndexedDB open failed'));
  });
}

function txDone(tx) {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error || new Error('IndexedDB transaction failed'));
    tx.onabort = () => reject(tx.error || new Error('IndexedDB transaction aborted'));
  });
}

async function putAll(storeName, items) {
  const db = await openDb();
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  store.clear();
  (items || []).forEach((item) => {
    if (item == null) return;
    const record = { ...item, id: String(item.id) };
    store.put(record);
  });
  await txDone(tx);
  db.close();
}

async function getAll(storeName) {
  const db = await openDb();
  const tx = db.transaction(storeName, 'readonly');
  const store = tx.objectStore(storeName);
  const rows = await new Promise((resolve, reject) => {
    const req = store.getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
  await txDone(tx);
  db.close();
  return rows;
}

async function setMeta(key, value) {
  const db = await openDb();
  const tx = db.transaction('cache_meta', 'readwrite');
  tx.objectStore('cache_meta').put({ key, value });
  await txDone(tx);
  db.close();
}

async function getMeta(key) {
  const db = await openDb();
  const tx = db.transaction('cache_meta', 'readonly');
  const row = await new Promise((resolve, reject) => {
    const req = tx.objectStore('cache_meta').get(key);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  await txDone(tx);
  db.close();
  return row ? row.value : null;
}

export async function saveMainLists({ songs, choreographies, associations }) {
  await Promise.all([
    putAll('songs', songs),
    putAll('choreographies', choreographies),
    putAll('associations', associations),
    setMeta('lastSyncAt', new Date().toISOString()),
  ]);
}

export async function loadCachedMainLists() {
  const [songs, choreographies, associations, lastSyncAt] = await Promise.all([
    getAll('songs'),
    getAll('choreographies'),
    getAll('associations'),
    getMeta('lastSyncAt'),
  ]);
  return { songs, choreographies, associations, lastSyncAt };
}

export function isOnline() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}
